"use client";

export const buildFrontendUrl = (path?: string, fallbackPath?: string) => {
  if (typeof window === "undefined") {
    return undefined;
  }

  const targetPath = path ?? fallbackPath ?? "/";
  return new URL(targetPath, window.location.origin).toString();
};
